const getAdvSearchFilter = state => {
  return state.advSearchFilters;
};

export default {
  getAdvSearchFilter
};
